import {Affix, FloatButton} from 'antd';
import {useEffect, useState} from 'react';
import '../ContentIndex.css';
const logoImg = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo2.png';
const img1 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/hj1.png';
const img2 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/hj2.jpg';
const img3 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/hj3.jpg';
const logo22 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo22.png';
const weixing = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/weixing.jpg';
const App = () => {
    useEffect(() => {
        // 配置swiper播放 配置项都写这里面
        // console.log(1232112312)
        // const mySwiper = new Swiper('.swiper', {
        //     autoplay: true,
        //     loop: true
        // })
        window.scrollTo(0, 0);

    }, [])
    const [scrollPosition, setScrollPosition] = useState(0);
    const [top, setTop] = useState(118);
    const scroll=(y)=>{
        window.scrollTo(0, y);
    }

    function createMarkup() {
        return {
            __html: `<div class="nyrcon">
                    <img src="`+img1+`" alt="焊接工艺评定" class="pprr">
                    <div class="nyrt"><h1 class="contact-tit">焊接工艺评定</h1></div>
                    <div class="cc-pp">
                        <h2><span style="font-size: 16px; color: rgb(0, 0, 0);">焊接工艺评定介绍</span></h2><p><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">焊接工艺评定</span></a><span style="color: rgb(0, 0, 0);">是通过对焊接接头的力学性能或其它性能的试验证实焊接工艺规程的正确性和合理性的一种程序。从焊接工艺角度，确保产品焊接接头使用性能的重要措施。它是按照所拟定的焊接工艺(包括焊前准备，焊接材料、设备、方法、顺序、操作的最佳选择，以及焊后处理等)，根据标准所规定的焊接试件、检验试样测定焊接接头是否具备所要求的性能。</span></p><p style="text-align: center;"><img src="`+img2+`" title="1664174273835391.jpg" alt="1664174273835391.jpg" width="342" height="227"></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);">焊接工艺评定过程</span></h2><p><span style="color: rgb(0, 0, 0);">（1）拟定预备焊接工艺指导书 (简称pWPS)；</span></p><p><span style="color: rgb(0, 0, 0);">（2）施焊试件和制取试样；</span></p><p><span style="color: rgb(0, 0, 0);">（3）检验试件和试样；</span></p><p><span style="color: rgb(0, 0, 0);">（4）测定焊接接头是否满足标准所要求的使用性能；</span></p><p><span style="color: rgb(0, 0, 0);">（5）提出</span><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">焊接工艺评定</span></a><span style="color: rgb(0, 0, 0);">报告对拟定的焊接工艺指导书进行评定。</span></p><p style="text-align: center;"><img src="`+img3+`" title="1664174180934402.jpg" alt="1664174180934402.jpg" width="342" height="227"></p><p style="text-align: center;"><span style="color: rgb(0, 0, 0);">焊接工艺评定流程</span></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);">对焊接工艺及焊接人员认证</span></h2><p><span style="color: rgb(0, 0, 0);">1、按照相关技术标准或技术文件对产品的原材料进行测试；</span></p><p><span style="color: rgb(0, 0, 0);">2、在实验室见证焊接过程及试验符合标准；</span></p><p><span style="color: rgb(0, 0, 0);">3、基于试验结果提供资格认证；</span></p><p><span style="color: rgb(0, 0, 0);">4、基于标准核实焊接人员的资格以及产品的性能。</span></p>                    </div>
                 </div>`
        };
    }

    return (

        <>
            <FloatButton.BackTop visibilityHeight={0}  style={{zIndex:9999999999999999}}/>
            <div className="fixed is_PC"></div>
            <div className="all_width is_PC">

                <div className="warp">
                    <div className="header">
                         <div className="logo"><a href="#/ContentIndex" style={{float:"left",marginRight:15}}><img src={logoImg} height={108}/></a></div>
                        <div className="new_nav">
                           <ul>
                                <li><a href="#/ContentIndex">首页</a></li>
                                <li><a  href="#/cnas">CNAS认可</a></li>
                                <li><a  href="#/cma">CMA认定</a></li>
                                <li><a  href="#/fanghuo">防火检测</a></li>
                                <li><a  href="#/haishui">海水腐蚀</a></li>
                                <li><a  href="#/jingxiang">金相抛光布</a></li>
                                <li><a   href="#/about">关于我们</a></li>
                            </ul>
                        </div>
                        <div className="vub_B" style={{position:"fixed",top:"30px"}}>联系电话： 18957441030</div>
                    </div>
                </div>
            </div>
            {/*<img src={yemei}/>*/}
            <div className={'service-details'} >
                <Affix offsetTop={top}>
                    <div className="l-box" >
                        <div className="s-plate">
                            <div className="d-nav">
                                <ul>
                                    <li onClick={event => scroll(419)}>
												<span>
													<i></i>焊接工艺评定介绍</span>
                                    </li>
                                    <li onClick={event => scroll(792)}>
												<span>
													<i></i>焊接工艺评定过程</span>
                                    </li>
                                    <li onClick={event => scroll(1327)}>
												<span>
													<i></i>对焊接工艺及焊接人员认证</span>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </Affix>
                <div className={'r-box'}>
                    <div dangerouslySetInnerHTML={createMarkup()}/>
                </div>
            </div>
            {/*<img src={xia} width={'100%'} style={{zIndex:999,position:"relative",marginTop:80,display:"block"}}/>*/}

             <div className="all_fnav is_PC" style={{zIndex:999,position:"relative"}}>
                 <div style={{background:'#fff',height:80}}></div>
                <div className="warp">
                    <div className={'b'}>
                        <img src={logo22} height={108} style={{float:"left"}}/>
                        <div style={{float:"right",lineHeight:'108px',fontSize:'26px',paddingRight:40}}>致力于我国实验室建设、 认证、 扩项、 监督评审、 一站式解决方案</div>
                    </div>
                    <div className="Fanya_footer_nav" style={{color:'#FFF'}}>
                        <ul>
                            <li>
                                
                                <div className="Fanya_footer_nav_TT">CMA资质认定</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>检验检测机构CMA资质认定</dt>
                                        <dt>机动车检验机构CMA资质认定</dt>
                                        <dt>司法鉴定机构CMA资质认定</dt>
                                        <dt>刑事技术机构CMA资质认定</dt>
                                    </dl>
                                </div>
                            </li>
                            <li><div className="Fanya_footer_nav_TT">CNAS认证认可</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>ISO17025检测/校准实验室CNAS认可</dt>
                                        <dt>ISO17020检验机构CNAS认可</dt>
                                        <dt>ISO15189医学实验室CNAS认可</dt>
                                        <dt>DILAC国防实验室认可</dt>
                                    </dl>
                                </div>
                            </li>
                            <li style={{marginRight:15}}>
                                <div className="Fanya_footer_nav_TT">联系我们</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>电话：0574-87636695</dt>
                                        <dt>认证热线：18957441030（胡老师）</dt>
                                        <dt>地址：宁波市高新区检验检测园冬青路258号A幢</dt>
                                        <dt></dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div className="Fanya_footer_sub" style={{position:"relative"}}>
                                    <img src={weixing} width={160} />
                                    <div style={{background:'red',borderRadius:16,lineHeight:'32px',textAlign:"center",width:160,marginTop:10}}>扫码咨询</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="all_Fanya_copyright">
                <div className="warp">
                    <div className="Fanya_copyright">版权所有 ◎ 浙江安鉴检测认证服务有限公司 <a
                        href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2024103308号-1</a></div>
                </div>
            </div>
        </>
    );
};
export default App;
